import React, { useEffect } from 'react'
import cx from 'classnames'
import { useSelector, useDispatch } from 'react-redux'
import withStyles from '@material-ui/core/styles/withStyles'
import MuiGrid from '@material-ui/core/Grid'
import url from 'front-end-core/core/url'
import connect from 'front-end-core/decorators/connect'
import { replaceUrl } from 'front-end-core/core/history'
import { DASHBOARD, CURRENT_AWARENESS } from 'constants/controllers'
import { requestGroup, requestHomePageArticles } from 'services/CurrentAwarenessService'
import ArticleContainer from 'redux/containers/pages/currentawarenessarticle/ArticleContainer'
import RecentStoriesContainer from 'redux/containers/pages/currentawarenessarticle/RecentStoriesContainer'
import { setHomepageArticles } from 'redux/actions'
import selectAolName from 'redux/selectors/selectAolName'
import ArrowLink from 'components/redesign/ArrowLink'
import ResponseConsumer from 'components/shared/ResponseConsumer'

const Grid = withStyles({
  item: {
    paddingTop: '0px !important'
  }
})(MuiGrid)

export const BackToHomeLink = ({ containerClassName, className }) => {
  const aol = useSelector(selectAolName)
  const homeUrl = url(DASHBOARD, { aol })

  return (
    <div className={cx(containerClassName)}>
      <div className={cx('flex items-center', className)}>
        <ArrowLink backArrow text='Back to home' url={homeUrl} />
      </div>
    </div>
  )
}

const ArticleGrid = ({ group, flavour, ...props }) => {
  if (!group) {
    return null
  }
  const article = group[0].groupSource.value[0]
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setHomepageArticles(props.homepageArticles))
  }, [props.homepageArticles, setHomepageArticles])

  return (
    <div className='article-grid pt9'>
      <div className='bg-ghost-grey'>
        <div className='layout-width-constraint'>
          <BackToHomeLink flavour={flavour} containerClassName='relative mb9' className='absolute bottom6' />
          <Grid container direction='row' justify='center' spacing={2}>
            <Grid item xs={12} sm={12} md={8}>
              <ArticleContainer {...{ ...props, ...article, flavour }} id={props.id} />
              <div className='ba b--cadet-blue mt5 dn db-t' />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <RecentStoriesContainer flavour={flavour} filterId={article.id} />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
}

const redirect = ({ flavour, id }) => replaceUrl(url(CURRENT_AWARENESS, { flavour, id }))

const ArticleGridWrapper = (props) => {
  const { group } = props

  return (
    <ResponseConsumer
      response={group}
      content={() => {
        if (group[0].id === '/') { /* TODO: Legacy, should remove in November [UPDATE: can delete now ?] */
          redirect(props)
          return null
        }
        return <ArticleGrid {...props} publishDate={group[0].title} />
      }}
      notfoundComponent={() => {
        redirect(props)
        return null
      }}
    />
  )
}

export default connect(
  ({ id, aol }) => ({
    group: requestGroup({ id, aol }),
    homepageArticles: requestHomePageArticles(aol)
  })
)(ArticleGridWrapper)
